import { useTranslation } from 'react-i18next';
import { ErrorResultA11y } from './ErrorResultA11y.tsx';
import { type IErrorResultBodyProps } from './ErrorResultBody.tsx';
import { OnPageResultContainer } from './OnPageResultContainer.tsx';

/**
 * Props condivise tra i componenti di errore.
 */
export function InternalErrorBody(props: IErrorResultBodyProps) {
  const { message, description, title } = props;
  const { t } = useTranslation();

  return (
    <OnPageResultContainer>
      <ErrorResultA11y
        status="error"
        title={
          title ??
          t('alert.internal-error-body.title', '500 Errore Interno del Server')
        }
        subTitle={
          message ??
          t(
            'alert.internal-error-body.subtitle',
            "Si è verificato un errore non previsto del server. Si prega di riprovare o contattare l'assistenza.",
          )
        }
        extra={description}
      />
    </OnPageResultContainer>
  );
}
